import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {HttpService} from "../http.service";
import {ChangePasswordRequest} from "../../shared/model/request/change-password.request";
import {ApiResponse} from "../../shared/model/response/ApiResponse";
import {AuthenticationResponse} from "../../shared/model/response/auth/authentication-response.model";
import {AccountResponse} from "../../shared/model/response/account-response.model";
import {HttpParams} from "@angular/common/http";
import {HttpUtils} from "../../shared/utils/http.utils";
import {AdminUserFilterModel} from "../../shared/model/request/admin-user-filter.model";
import {DatePipe} from "@angular/common";
import {UserBlockRequest} from "../../shared/model/request/user-block.model";

/**
 * The account service provides service for the user account such as password change
 * profile fetching, user submissions, and such
 */
@Injectable({providedIn: "root"})
export class AccountService {

  private version = "/api/v1/"
  private host = environment.host + this.version
  url: string = this.host + "accounts"

  constructor(
    private http: HttpService,
    private datePipe: DatePipe
  ) {
  }

  changePassword(body: ChangePasswordRequest): Observable<ApiResponse<AuthenticationResponse>> {
    return this.http.put(this.url + '/password', body, {shouldShowLoading: false})
  }

  getAccountById(id: number, params: {}): Observable<ApiResponse<AccountResponse>> {
    let queryParams = new HttpParams({fromObject: params})
    return this.http.get(this.url + '/' + id, {
      params: queryParams,
      shouldShowLoading: true,
    })
  }

  updateAccount(body: { firstname: string, lastname: string }): Observable<ApiResponse<AccountResponse>> {
    return this.http.put(this.url, body, {shouldShowLoading: true})
  }

  getRole(): Observable<ApiResponse<{ role: string }>> {
    return this.http.get(this.url + "/role", {shouldShowLoading: true})
  }

  updateRole(body: { userId: number, role: string }): Observable<ApiResponse<AccountResponse>> {
    return this.http.patch(this.url + "/role", body, {shouldShowLoading: false})
  }

  blockAccount(body: UserBlockRequest): Observable<ApiResponse<AccountResponse>> {
    return this.http.put(this.url + "/block", body, {shouldShowLoading: false})
  }

  removePhoneNumber(userId: number): Observable<ApiResponse<AccountResponse>> {
    return this.http.put(this.url.concat("/", userId.toString(), "/contact-remove"), {shouldShowLoading: false})
  }

  addPhoneNumber(body: { phoneNumber: string, phoneValidationCode : string}): Observable<ApiResponse<AccountResponse>> {
    return this.http.put(this.url.concat("/contact-add"), body, {shouldShowLoading: false})
  }

  unblock(userId: number): Observable<ApiResponse<AccountResponse>> {
    const url = this.url.concat("/unblock/", userId.toString())
    return this.http.put(url, {shouldShowLoading: true})
  }

  list(page: number = 0, filters: AdminUserFilterModel) {

    //convert date fields
    if (filters.creationDate) filters.creationDate = this.datePipe.transform(filters.creationDate, 'yyyy-MM-dd');

    let params = HttpUtils.convertObjectToParam(filters).append("page", page)

    return this.http.get(this.url, {params, shouldShowLoading: true});
  }


  validatePhoneNumber(phoneNumber: string): Observable<ApiResponse<any>> {

    let requestBody = {phoneNumber: phoneNumber,}

    return this.http.put(this.url + "/contact-validate", requestBody, {shouldShowLoading: false})
  }
}
